import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../store';
import type { ISelectOption } from '../../../../../utils/types';

interface UseParentOptionsParams {
  selectedClientId?: number;
  parentOneId?: number;
  parentTwoId?: number;
}

function useParentOptions({ selectedClientId, parentOneId, parentTwoId }: UseParentOptionsParams) {
  const { clientFamilyBackground } = useSelector(
    (state: RootState) => state.clientFamilyBackgrounds,
  );

  const parentOptions = useMemo<ISelectOption[]>(() => {
    if (!selectedClientId || !clientFamilyBackground) return [];

    return (
      clientFamilyBackground.parents_and_caregivers?.map((parentCaregiver) => ({
        value: parentCaregiver.id,
        label: parentCaregiver.name,
      })) ?? []
    );
  }, [clientFamilyBackground, selectedClientId]);

  const parentOneOptions = useMemo(() => {
    if (!parentTwoId) return parentOptions;
    return parentOptions.filter((option) => option.value !== parentTwoId);
  }, [parentOptions, parentTwoId]);

  const parentTwoOptions = useMemo(() => {
    if (!parentOneId) return [];
    return parentOptions.filter((option) => option.value !== parentOneId);
  }, [parentOptions, parentOneId]);

  return {
    parentOneOptions,
    parentTwoOptions,
  };
}

export default useParentOptions;
